
import { SET_INSIGHT_DATA } from '../actionTypes'
// import moment from 'moment'
// import _ from 'lodash'

const initialState = null

export default (state=initialState,  payload) => {
    switch(payload.type) {

    case SET_INSIGHT_DATA:
        return payload.insightData || null
    
    default:
        return state
    }
}